import React from 'react';
import { Box, IconButton, Icon, Grid, useTheme } from '../../../../base';
import {
    IServerJobApplicationEmail,
    formatMessageTime,
    Directions,
} from '../../../../common';
import {
    StyledAvatar,
    StyledFullName,
    StyledTimeText,
    StyledEmailAddress,
    StyledSubject,
    StyledBody,
} from '../EmailTab.styles';
import {
    StyledContainer,
    StyledHeader,
    StyledTopRow,
    StyledContent,
    StyledButton,
} from './EmailDetail.styles';
import FilesList from '../../../FilesList';
import { useTranslation } from 'react-i18next';

interface Props {
    emailData: IServerJobApplicationEmail;
    onBack: () => void;
}

const EmailDetail = (props: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { emailData, onBack } = props;
    const { user, subject, body, files, carbon_copy, created_at } = emailData;

    const fullName = `${user.first_name} ${user.last_name}`;
    const userImage = user.image;
    const formattedTime = formatMessageTime(created_at);

    return (
        <StyledContainer>
            <StyledHeader>
                <IconButton onClick={onBack} sx={{ height: 25, width: 25 }}>
                    <Icon
                        name={
                            theme.direction === Directions.rtl
                                ? 'ArrowForwardIcon'
                                : 'ArrowBackIcon'
                        }
                        size={20}
                    />
                </IconButton>
                <StyledAvatar name={fullName} src={userImage} />
                <Box>
                    <StyledTopRow>
                        <StyledFullName>{fullName}</StyledFullName>
                        <StyledTimeText variant="caption">
                            {formattedTime}
                        </StyledTimeText>
                    </StyledTopRow>
                    <StyledEmailAddress>{user.email}</StyledEmailAddress>
                </Box>
            </StyledHeader>
            <StyledContent spacing={0.5}>
                <StyledSubject variant="body1">{subject}</StyledSubject>
                <StyledBody variant="body2">{body}</StyledBody>
                {files?.length > 0 && (
                    <FilesList
                        files={files}
                        onForward={() => {
                            //TODO: Implement file forward functionality
                        }}
                    />
                )}
                <Grid container gap={1} sx={{ paddingTop: 2 }}>
                    <StyledButton
                        variant="outlined"
                        startIcon={<Icon name="ReplyIcon" />}
                    >
                        {t('jobApplicationPage.reply')}
                    </StyledButton>
                    <StyledButton
                        variant="outlined"
                        startIcon={<Icon name="ShortcutOutlinedIcon" />}
                    >
                        {t('jobApplicationPage.forward')}
                    </StyledButton>
                    {carbon_copy?.length > 0 && (
                        <StyledButton
                            variant="outlined"
                            startIcon={<Icon name="ReplyAllIcon" />}
                        >
                            {t('jobApplicationPage.replyAll')}
                        </StyledButton>
                    )}
                </Grid>
            </StyledContent>
        </StyledContainer>
    );
};

export default EmailDetail;
